import NoConformidadesRoutes from './modules/noconformidades/routes';

export default [
  ...NoConformidadesRoutes,
];
